var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import render from 'utils/render';
const SvgRta = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  const Element = render.element(/*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.32 12",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aa7554ff-40fd-4011-8f48-7277a9f12b4d",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a67d8643-886f-4d5b-b0ce-c721824a845e",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a1b1a395-67aa-4a84-b039-d22a1c2d0b7c",
    "data-name": "RTA",
    d: "M0,12V0H26.15l4.17,12H26.73l-.54-2h-3.9l-.53,2h-3.5l3.13-9H16.8v9H13.38V3H10a3.83,3.83,0,0,1-.37,2.09A3.34,3.34,0,0,1,7.45,6.71,3.13,3.13,0,0,1,9.26,8.52L10.91,12H7L5.21,8.34c-.34-.68-.7-1.2-1.46-1.2H3.44V12ZM25.48,7.43l-1.23-4.3L23,7.43Zm-22-2.6h1.5c.85,0,1.6-.3,1.6-1.18,0-1.16-.8-1.2-1.59-1.2H3.44Z"
  }))))));
  return /*#__PURE__*/React.createElement(Element.type, _extends({}, Element.props, {
    ref: ref
  }), children, Element.props.children);
});
export default /*#__PURE__*/React.memo(SvgRta);